import { useEffect, useState } from "react";
import { api } from "./api";

export function useBuyerFeePct() {
  const [pct, setPct] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setPct(r.data.global_buyer_fee_pct)).catch(() => {}); }, []);
  return pct;
}
